import { rem } from 'polished';

const onAnimation = (event, home) => {
  const [...pager] = document.getElementsByClassName('pager');
  const [...box] = document.getElementsByClassName('box');
  /* eslint-disable */
  if (event.type === "mouseenter" && !home) {
    pager.map(el => {
      el.style.bottom = rem("110px");
    });
    box.map(el => {
      el.style.transform = "translate3d(0, 0, 0)";
    });
  }
  if (event.type === "mouseleave") {
    pager.map(el => {
      el.style.bottom = rem("0px");
    });
    box.map(el => {
      el.style.transform = "translate3d(0, 100%, 0)";
    });
  }
};

export { onAnimation };
